export default __webpack_public_path__ + "static/media/img-person.c9023c22.png";